import React from 'react'
import { Field, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { Icon, Button } from 'semantic-ui-react'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import Approvers from 'routes/ProcurementSystem/Shared/DocumentStep/Approvers'
import ModalSelectPO from '../ModalSelectPO'
import { purchaseOrderDetailPath, purchaseOrderUpdateDetailPath } from 'routes'

import { FieldRow } from '../styled'
import { LinkDetail } from './styled'

const ContractInformation = (props) => {
  const {
    contractWorkflowData,
    valueForm,
    // props
    isEdit = false,
    isCreate = false,
    isDetail = false
  } = props

  const [showModalSelectPO, setShowModalSelectPO] = React.useState(false)

  const submitModalSelectPO = (value) => {
    setShowModalSelectPO(false)
  }

  return (
    <StdCard title='Information' style={{ marginTop: '10px' }}
      accessoriesHeader={
        <React.Fragment>
          {!isDetail&&<Approvers 
            approvers={contractWorkflowData.data} 
            // status={valueForm&&valueForm.status}
            trigger={
              <Button 
                basic  
                circular 
                type='button' 
                loading={contractWorkflowData.loading} 
                content='View Approver' 
                labelPosition='right'
                icon='sort numeric down' />
            }
          />}
          {!isCreate&&(valueForm&&valueForm.urlPowerApps)&&
            <Button 
              basic  
              circular 
              type='button' 
              content='View Contract Detail' 
              labelPosition='right'
              icon='file alternate'
              onClick={()=>window.open(valueForm.urlPowerApps)} />
          }
        </React.Fragment>
      }>
      <FieldRow>
        <Field
          name='title'
          label='Title'
          type={type.text}
          component={FieldInput}
          className={`${(isCreate?'halfRow':'')}`}
          editable={!isDetail}
          require
          tooltip={isDetail}
        />
        {!isCreate&&
        <Field 
          name='documentNumber' 
          label='Document No'
          type={type.text}
          editable={false}
          component={FieldInput}
          showEmpty
        />}
      </FieldRow>
      <FieldRow>
        <Field 
          name='poSelectedNumber' 
          label='PO No'
          editable={false}
          type={type.textSearch}
          component={FieldInput}
          placeHolder='Select Purchase Order'
          className={valueForm&&!valueForm.referencePoUpdateId?'halfRow':''}
          onSearchClick={()=>{
            setShowModalSelectPO(true)
          }}
          showSearch={!isDetail&&valueForm&&valueForm.status!=5}
          showPODetail={()=>{
              if(valueForm&&valueForm.poId){
                return(
                  <LinkDetail onClick={()=>window.open(purchaseOrderDetailPath(valueForm.poId))}>
                    PO Detail <Icon color='orange' name='file alternate' />
                  </LinkDetail>
                )
              }else{
                return null
              }
            }
          }
          require
        />
        {valueForm&&valueForm.referencePoUpdateId?
        <Field 
          name='referencePoUpdateDoc' 
          label='PO Update'
          editable={false}
          type={type.textSearch}
          component={FieldInput}
          showSearch={false}
          showPODetail={()=>{
              if(valueForm&&valueForm.referencePoUpdateId){
                return(
                  <LinkDetail onClick={()=>window.open(purchaseOrderUpdateDetailPath(valueForm.referencePoUpdateId))}>
                    PO Update <Icon color='orange' name='file alternate' />
                  </LinkDetail>
                )
              }else{
                return null
              }
            }
          }
        />:null}
      </FieldRow>
      <FieldRow>
        <Field 
          name='companyName' 
          label='Company'
          type={type.text}
          component={FieldInput}
          editable={false}
        />
        <Field 
          name='projectName' 
          label='Project'
          type={type.text}
          editable={false}
          component={FieldInput}
          showEmpty
        />
      </FieldRow>
      <FieldRow>
        <Field
          name="requesterUser"
          label="Requester"
          require
          component={FieldInput}
          allowAdditions={false}
          editable={!isDetail}
          loading={props.members.loading}
          options={props.members.map((m,i) => ({
            key:i,
            value: m.username.toLowerCase(),
            text: `${m.firstnameEn} ${m.lastnameEn}`,
          }))}
          type={type.select}
        />
        <Field 
          name='vendorName' 
          label='Vendor'
          type={type.text}
          component={FieldInput}
          editable={false}
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='documentDate' 
          label='Document Date'
          type={type.date}
          editable={false}
          component={FieldInput}
          className={`${isDetail?'':'halfRow'}`}
        />
        {(isDetail)&&
        <Field 
          name='submittedDate' 
          label='Submitted Date'
          type={type.date}
          editable={false}
          component={FieldInput}
        />}
      </FieldRow>
      <FieldRow>
        <Field
          name="remark"
          label="Remark"
          component={FieldInput}
          allowAdditions={false}
          editable={!isDetail}
          type={type.textArea}
        />
      </FieldRow>

      {showModalSelectPO&&
      <ModalSelectPO 
        onSubmit={(value)=>submitModalSelectPO(value)}
        onClose={()=>setShowModalSelectPO(false)}
      />}
    </StdCard>
  )
}
const mapStateToProps = (state, props) => {
  return ({
    members: state.member.members,
    poCompleteList: state.contract.poCompleteList,
    contractWorkflowData: state.contract.contractWorkflowData,
    valueForm: getFormValues('formContract')(state),
  })
}

const mapDispatchToProps = {
}


export default connect(mapStateToProps, mapDispatchToProps)(ContractInformation)